export function bookmarkUrlKey(url) {
  return String(url || '').trim().replace(/\/+$/, '').toLowerCase();
}

export function urlsMatch(a, b) {
  const left = bookmarkUrlKey(a);
  const right = bookmarkUrlKey(b);
  return !!left && left === right;
}
